import React from 'react';
import { AddButton, AppContent, Icon, Link } from '@common/components';
import { useSetBreadcrumbs } from 'works/legacy/lib/client-store';
import { StaffingRequestList } from './staffing-request-list';
import { Dropdown, Row } from 'antd';
import { useCurrentMembership, useCurrentEntity } from '@identity/hooks';

export function StaffingRequestsPage() {
  useSetBreadcrumbs([
    { name: 'Staffing', path: `/works/staffing-requests/requests` },
  ]);

  const currentMembership = useCurrentMembership();
  const currentEntity = useCurrentEntity();

  const onDemandEnabled: boolean = currentMembership
    ? currentEntity.onDemandEnabled
    : false;

  const showStaffingPage: boolean = currentMembership
    ? currentMembership.canShowSidebarStaffingItem
    : false;

  const dropdownMenuItems = [
    {
      label: (
        <Link to="/works/staffing-requests/templates/long_term">Long Term</Link>
      ),
      key: 'long_term',
    },
    ...(onDemandEnabled
      ? [
          {
            label: (
              <Link to="/works/staffing-requests/templates/on_demand">
                Per Diem
              </Link>
            ),
            key: 'on_demand',
          },
        ]
      : []),
  ];

  if (!showStaffingPage) {
    return <></>;
  }

  return (
    <AppContent>
      <Row justify="end">
        <Dropdown
          menu={{
            items: dropdownMenuItems,
          }}
          placement="bottomRight"
        >
          <AddButton>
            Request
            <Icon icon="chevronDown" size="sm" kind="regular" />
          </AddButton>
        </Dropdown>
      </Row>
      <section className="staffingRequestList">
        <StaffingRequestList onDemandEnabled={onDemandEnabled} />
      </section>
    </AppContent>
  );
}
